import { About } from "../components/about/about";

export const AboutPage = () => {
  return <About />;
};
